module.exports = __webpack_public_path__ + "static/media/nautral-sciences.80740b91.webp";